<template>
  <div v-if="ShowAi" class="warp">
    <yxt-divider direction="vertical"></yxt-divider>
    <div class="icon-warp"  @click="show = true">
      <yxt-image :class="isStu ? 'is-stu' : tiny ? 'is-tiny' : 'is-manage'" class="ai-icon"
        :src="`${staticBaseUrl}ufd/407a24/assistent/pc/img/avatar.jpg`"></yxt-image>
      <yxt-svg :remote-url="`${staticBaseUrl}assets/cc14e4ef/0a2d2173/`" width="22px" height="15px" icon-class="ai-3" class="ai-svg" />
    </div>
    <div v-if="isXxv2">
      <yxtbiz-ai-robot v-show="show"  @close="show = false"></yxtbiz-ai-robot>
    </div>
    <div v-if="!isXxv2">
      <yxtbiz-ai-robot-demo   v-show="show" @close="show = false"></yxtbiz-ai-robot-demo>
    </div>
  </div>
</template>

<script>
import { enmuFunctions } from '../../../function-points/index';
import { checkTimeOutFnc } from '../../../common-util/getFactor';
const isFunPointHide = point => {
  // 无 point code 不隐藏元素
  if (!point) return false;
  // 没有匹配状态 hide
  return [undefined, null, 0, 1, 3, 5].includes(checkTimeOutFnc(point));
};
export default {
  props: {
    isStu: {
      type: Boolean,
      default: false
    },
    tiny: {
      type: Boolean,
      default: false
    },
    isXxv2: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      show: false,
      staticBaseUrl: window.feConfig.common.staticBaseUrl
    };
  },
  computed: {
    ShowAi() {
      return (this.isXxv2 && this.openAi) || (!this.isXxv2);
    },
    openAi() {
      return !isFunPointHide(enmuFunctions.AI_BOB);
    }
  }
};
</script>

<style lang="scss" scoped>
.warp {
  display: flex;
  align-items: center;

  .icon-warp {
    position: relative;
    cursor: pointer;
    .ai-svg{
      position: absolute;
      top:-7px;
      right: 2px;
    }
    .ai-icon {
      margin: 0 16px;
      display: inline-block;
    }

    .is-stu {
      width: 36px;
      height: 36px;
    }

    .is-manage {
      width: 30px;
      height: 30px;
    }

    .is-tiny {
      width: 20px;
      height: 20px;
    }
  }

}
</style>